"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KHAudioMixer = exports.KHAudioTrack = void 0;
class KHAudioTrack {
    constructor(scene, key, mixer, volume = 1) {
        this.key = key;
        this.sound = scene.sound.add(key);
        this.volume = volume;
        this.mixer = mixer;
    }
    play(volume = 1) {
        this.sound.play({ volume: this.mixer.mixerVolume * this.volume * volume });
    }
    setPitch(amount) {
        if (this.sound instanceof Phaser.Sound.WebAudioSound || this.sound instanceof Phaser.Sound.HTML5AudioSound) {
            this.sound.setDetune(amount);
        }
    }
}
exports.KHAudioTrack = KHAudioTrack;
class KHAudioMixer {
    constructor() {
        this.sounds = new Map();
    }
    ensureSound(scene, key, volume = 1) {
        let audio = this.sounds.get(key);
        if (audio == null) {
            audio = new KHAudioTrack(scene, key, this, volume);
            this.sounds.set(key, audio);
        }
        return audio;
    }
    playSound(key, volume = 1) {
        const audio = this.sounds.get(key);
        audio === null || audio === void 0 ? void 0 : audio.play();
    }
}
exports.KHAudioMixer = KHAudioMixer;
